let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3K7HO")).then(() => parcelRequire('l2yEk'));